/*
 * Copyright (c) Dito Technologies
 */

import React from "react"
import styles from "./Root.module.scss"
import ContentWrapper from "ui/common/ContentWrapper";
import Header1 from "ui/kit/typography/Header1";
import Body from "ui/kit/typography/Body";
import RootStepper from "ui/feature/root/RootStepper";
import {initialState, Reducer} from "ui/feature/root/FormReducer";
import RootWorkspace from "ui/feature/root/RootWorkspace";
import {QueryRenderer} from "react-relay";
import environment from "constants/environment";
import query from "ui/feature/root/RootQuery";
import {RootQuery} from "ui/feature/root/__generated__/RootQuery.graphql";
import ErrorSection from "ui/common/ErrorSection";
import LoadingSection from "ui/common/LoadingSection";
import RootOnWaitlist from "ui/feature/root/RootOnWaitlist";

const Root: React.FC = () => {

    const [state, dispatch] = React.useReducer(Reducer, initialState)

    return (
        <QueryRenderer<RootQuery>
            environment={environment}
            query={query}
            variables={{}}
            render={({error, props, retry}) => {
                if (error) {
                    return <ErrorSection/>
                } else if (props && !props.music_viewer.account.on_waitlist) {
                    return <ContentWrapper>
                        <Header1>Sheet Music Converter</Header1>
                        <Body>Complete the steps below to convert your images or sheet music into a MIDI format.</Body>
                        <div className={styles.workspaceContainer}>
                            <RootStepper dispatch={dispatch} state={state}/>
                            <RootWorkspace dispatch={dispatch} state={state}/>
                        </div>
                    </ContentWrapper>
                } else if (props) {
                    return <RootOnWaitlist/>;
                } else {
                    return <LoadingSection/>;
                }
            }}/>
    );
}

export default Root;